import type { User } from 'firebase/auth';

import { queryClient } from '@/app/providers/queryClient';
import { ANALYTICS_EVENTS, analytics, logger, setUser } from '@/shared';

import { sessionStore } from './store.js';
import type { SessionUser } from './types.js';

export function toSessionUser(user: User): SessionUser {
  return {
    id: user.uid,
    phoneNumber: user.phoneNumber ?? undefined,
    isAnonymous: user.isAnonymous,
  };
}

export function handleSessionUserChanged(user: SessionUser | null): void {
  if (!user) {
    logger.info('session state: unauthenticated', { source: 'entities/session' });
    void analytics.track({
      name: ANALYTICS_EVENTS.session.unauthenticated,
      context: { actor: 'clinician' },
    });
    setUser(null);
    queryClient.clear();
    sessionStore.set({ status: 'unauthenticated', user: null });
    return;
  }

  logger.info('session state: authenticated', {
    source: 'entities/session',
    isAnonymous: user.isAnonymous,
    hasPhoneNumber: user.phoneNumber != null,
  });
  void analytics.track({
    name: ANALYTICS_EVENTS.session.authenticated,
    context: { actor: 'clinician' },
    properties: {
      isAnonymous: user.isAnonymous,
      hasPhoneNumber: user.phoneNumber != null,
    },
  });
  setUser({
    firebaseUserId: user.id,
    phoneNumber: user.phoneNumber,
  });
  sessionStore.set({ status: 'authenticated', user });
}
